import {
  startLoading,
  stopLoading,
} from '../../../common/modules/loading/actions'
import { LoadingTypes } from '../../../common/modules/loading/reducer'
import { updateAppAlert } from '../../../common/modules/appAlert/actions'
import { AxiosError, AxiosResponse } from 'axios'
import { RequestFailureMessage } from '../../../common/utils/messagesContants'
import { AppDispatch, RootState } from '../../../store'
import { camelize } from 'casing'
import { getErrorMessages } from '../../../common/utils/error'
import { errorLogger } from '../../../common/utils/errorLogger'
import { CloudMarketplace } from '../productsListing/reducer'
import { AnyAction } from '@reduxjs/toolkit'
import { getSubscriptionsAPIBasedOnCloud } from '../subscription/action'
export enum ModalSubscriptionsActionTypes {
  SET_MODAL_SUBSCRIPTIONS_DATA = 'SET_MODAL_SUBSCRIPTIONS_DATA',
  CLEAR_MODAL_SUBSCRIPTIONS_DATA = 'CLEAR_MODAL_SUBSCRIPTIONS_DATA',
}

export const getModalSubscriptions =
  ({
    partnerId,
    productId,
    cloudMarketplace,
    pageSize,
    pageNumber,
    crmOpportunityId,
    input,
    selectedInput,
    sectionName,
    status,
    expiringDays,
    privateOfferId,
    sortBy,
    sortOrder,
  }: {
    partnerId: string
    productId?: string
    cloudMarketplace: CloudMarketplace
    pageSize?: number
    pageNumber?: number
    crmOpportunityId?: string
    input?: string
    selectedInput?: string
    sectionName?: string
    status?: string
    expiringDays?: string
    privateOfferId?: string
    sortBy?: string
    sortOrder?: 'asc' | 'desc'
  }) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    await dispatch(startLoading(LoadingTypes.GENERAL))
    try {
      const isGcp = cloudMarketplace === 'GCP'
      const response = await getSubscriptionsAPIBasedOnCloud(
        partnerId,
        cloudMarketplace,
        productId,
        pageSize,
        pageNumber,
        crmOpportunityId,
        input,
        selectedInput,
        sectionName,
        status,
        expiringDays,
        privateOfferId,
        isGcp ? sortBy : undefined,
        isGcp ? sortOrder : undefined
      )
      dispatch(
        await setSubscriptionsData(camelize({ ...response?.data, pageNumber }))
      )
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(errorResponse),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      await dispatch(stopLoading(LoadingTypes.GENERAL))
    }
  }


export const clearModalSubscriptions = () =>
  ({
    type: ModalSubscriptionsActionTypes.CLEAR_MODAL_SUBSCRIPTIONS_DATA,
  }) as unknown as AnyAction

export const setSubscriptionsData = (data: Record<string, unknown>) =>
  ({
    type: ModalSubscriptionsActionTypes.SET_MODAL_SUBSCRIPTIONS_DATA as ModalSubscriptionsActionTypes.SET_MODAL_SUBSCRIPTIONS_DATA,
    payload: {
      data: data.subscriptions || [],
      pageNumber: data.pageNumber,
      count: data.count ?? 0,
      sortBy: data.sortBy ?? '',
      sortOrder: data.sortOrder ?? 'desc',
    },
  }) as unknown as AnyAction
